const greetingTextMobile = {
    en: `Hi there! I'm Maxine!`,
    nl: `Hallo! Ik ben Maxine! Wat is jouw naam?`
  };
  
  export default greetingTextMobile;
  